// extracted by mini-css-extract-plugin
export var lbContainerOuter = "x_tS";
export var lbContainerInner = "x_tT";
export var movingForwards = "x_tV";
export var movingForwardsOther = "x_tW";
export var movingBackwards = "x_tX";
export var movingBackwardsOther = "x_tY";
export var lbImage = "x_tZ";
export var lbOtherImage = "x_t0";
export var prevButton = "x_t1";
export var nextButton = "x_t2";
export var closing = "x_t3";
export var appear = "x_t4";